import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import VideoPlayer from "../../../shared/video/video_room/player/video_player";
import Select from "react-select";

const RenderedVideoRoom = ({videoRoomId}) => {
  const videoRooms = useSelector(state => state.videoRooms)
  const videoRoom = videoRooms?.find(vr => vr.id === videoRoomId)

  if (!videoRoom) {
    return <div className={"alert alert-danger"}>
      NO VIDEO ROOM FOUND FOR VIDEO-ROOM DIV. No video rooms available in state.
    </div>
  }

  return <VideoPlayer videoRoom={videoRoom}/>
}

const VideoRoomCellPlugin = {
  Renderer: (props) => {
    const {video_room_id} = props.data
    return <RenderedVideoRoom videoRoomId={video_room_id}/>
  },

  id: 'video-room-cell-plugin',
  title: 'Video Room',
  description: 'Add a video room',
  version: 1,
  allowClickInside: true,
  toolbar_element: document.createElement('div'),
  controls: {
    type: 'custom',
    allowClickInside: true,
    Component: (props) => {
      console.log("VR Component", props)
      const videoRooms = useSelector(state => state.videoRooms)
      const options = videoRooms.map(videoRoom => ({value: videoRoom.id, label: videoRoom.title}))

      return <div className="form-group">
        <label>Video Room</label>
        <Select
          defaultValue={options.find(o => o.value === props.data.video_room_id)}
          options={options}
          menuPortalTarget={document.body}
          styles={{menuPortal: base => ({...base, zIndex: 9999})}}
          onChange={val => props.onChange({video_room_id: val.value})}
        />
      </div>
    },
  },
  // editorRef: "ABC",
  // controls: {
  //   type: 'autoform',
  //   schema: {
  //     properties: {
  //       url: {
  //         type: 'string',
  //         default: 'https://flave.at',
  //       },
  //     },
  //     required: ['url'],
  //   },
  // },
}

export default VideoRoomCellPlugin